import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './ETFs.css';

const ETFs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const etfsArticles = [
    {
      id: 1,
      category: 'EQUITY ETFs',
      title: 'S&P 500 ETFs See Record $12 Billion Weekly Inflows',
      subtitle: 'Investors pile into broad market index funds amid tech sector rally',
      date: 'January 27, 2026',
      time: '1 hour ago',
      image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&h=450&fit=crop',
      slug: 'sp500-etfs-record-inflows'
    },
    {
      id: 2,
      category: 'BOND ETFs',
      title: 'Corporate Bond ETFs Surge on Rate Cut Expectations',
      subtitle: 'Fixed income funds attract investors seeking yield amid falling treasury rates',
      date: 'January 27, 2026',
      time: '3 hours ago',
      image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=800&h=450&fit=crop',
      slug: 'corporate-bond-etfs-surge'
    },
    {
      id: 3,
      category: 'COMMODITY ETFs',
      title: 'Gold ETFs Hit 3-Year High as Dollar Weakens',
      subtitle: 'Precious metals funds see strongest demand since 2023',
      date: 'January 26, 2026',
      time: '1 day ago',
      image: 'https://images.unsplash.com/photo-1610375461246-83df859d849d?w=800&h=450&fit=crop',
      slug: 'gold-etfs-three-year-high'
    },
    {
      id: 4,
      category: 'SECTOR ETFs',
      title: 'Tech Sector ETFs Lead Market with 28% Annual Returns',
      subtitle: 'AI and semiconductor funds dominate performance rankings',
      date: 'January 26, 2026',
      time: '1 day ago',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=450&fit=crop',
      slug: 'tech-sector-etfs-lead'
    }
  ];

  // ETF News List - Left Column
  const etfsListLeft = [
    { id: 1, title: 'Vanguard Total Stock Market ETF Hits Record $1.5T in Assets', time: '45 minutes ago', image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=50&h=50&fit=crop', slug: 'vanguard-total-stock-etf-record-assets' },
    { id: 2, title: 'iShares Core S&P 500 ETF Sees $8B Weekly Inflows', time: '1 hour ago', image: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=50&h=50&fit=crop', slug: 'ishares-core-sp500-weekly-inflows' },
    { id: 3, title: 'Emerging Market ETFs Post Strongest Quarter Since 2020', time: '2 hours ago', image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=50&h=50&fit=crop', slug: 'emerging-market-etfs-strongest-quarter' },
    { id: 4, title: 'Thematic ETFs Launch Focused on Artificial Intelligence', time: '3 hours ago', image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=50&h=50&fit=crop', slug: 'thematic-etfs-artificial-intelligence' },
    { id: 5, title: 'Bitcoin ETF Options Trading Begins on Major Exchanges', time: '4 hours ago', image: 'https://images.unsplash.com/photo-1621761191319-c6fb62004040?w=50&h=50&fit=crop', slug: 'bitcoin-etf-options-trading-begins' },
    { id: 11, title: 'High-Yield Bond ETFs Attract Institutional Money', time: '5 hours ago', image: 'https://images.unsplash.com/photo-1579621970795-87facc2f976d?w=50&h=50&fit=crop', slug: 'high-yield-bond-etfs-institutional-flows' },
    { id: 12, title: 'Small-Cap ETF Launches Target Value Investors', time: '6 hours ago', image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=50&h=50&fit=crop', slug: 'small-cap-etf-value-investors' },
    { id: 13, title: 'European Equity ETFs See Unexpected Surge in Demand', time: '7 hours ago', image: 'https://images.unsplash.com/photo-1587355760421-b9de3226a046?w=50&h=50&fit=crop', slug: 'european-equity-etfs-demand-surge' },
    { id: 14, title: 'Dividend Aristocrat ETFs Outperform Broader Market', time: '8 hours ago', image: 'https://images.unsplash.com/photo-1554224311-61a1d6be0bf1?w=50&h=50&fit=crop', slug: 'dividend-aristocrat-etfs-outperform' },
    { id: 15, title: 'Clean Energy ETF Assets Cross $100B Milestone', time: '9 hours ago', image: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=50&h=50&fit=crop', slug: 'clean-energy-etf-100b-milestone' }
  ];

  // ETF News List - Right Column
  const etfsListRight = [
    { id: 6, title: 'Inverse ETFs Experience Record Inflows Amid Volatility', time: '1 hour ago', image: 'https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?w=50&h=50&fit=crop', slug: 'inverse-etfs-record-inflows-volatility' },
    { id: 7, title: 'Gold ETF Holdings Reach Five-Year High on Uncertainty', time: '2 hours ago', image: 'https://images.unsplash.com/photo-1610375461246-83df859d849d?w=50&h=50&fit=crop', slug: 'gold-etf-holdings-five-year-high' },
    { id: 8, title: 'Actively Managed ETFs Take Market Share from Passive', time: '3 hours ago', image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=50&h=50&fit=crop', slug: 'actively-managed-etfs-market-share' },
    { id: 9, title: 'Real Estate ETFs Rally on Commercial Recovery Signals', time: '4 hours ago', image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=50&h=50&fit=crop', slug: 'real-estate-etfs-commercial-recovery' },
    { id: 10, title: 'Treasury Bond ETFs Face Largest Outflows This Year', time: '5 hours ago', image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=50&h=50&fit=crop', slug: 'treasury-bond-etfs-outflows' },
    { id: 16, title: 'Semiconductor ETF Launches Capitalize on Chip Demand', time: '6 hours ago', image: 'https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?w=50&h=50&fit=crop', slug: 'semiconductor-etf-chip-demand' },
    { id: 17, title: 'ESG ETF Fee War Intensifies Among Major Providers', time: '7 hours ago', image: 'https://images.unsplash.com/photo-1579532537598-459ecdaf39cc?w=50&h=50&fit=crop', slug: 'esg-etf-fee-war-providers' },
    { id: 18, title: 'International Bond ETFs Benefit from Rate Differentials', time: '8 hours ago', image: 'https://images.unsplash.com/photo-1569025690938-a00729c9e1f9?w=50&h=50&fit=crop', slug: 'international-bond-etfs-rate-differentials' },
    { id: 19, title: 'Leveraged Tech ETFs Draw Speculation Amid AI Boom', time: '9 hours ago', image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=50&h=50&fit=crop', slug: 'leveraged-tech-etfs-ai-boom' },
    { id: 20, title: 'Infrastructure ETFs Launch Targeting Biden Plan Beneficiaries', time: '10 hours ago', image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=50&h=50&fit=crop', slug: 'infrastructure-etfs-biden-plan' }
  ];

  return (
    <>
      <Helmet>
        <title>ETF News & Analysis - Exchange-Traded Funds | Redbox Global</title>
        <meta name="description" content="Latest ETF market news, fund flows, and performance analysis. Coverage of equity ETFs, bond ETFs, commodity funds, and sector-specific exchange-traded funds." />
        <meta name="keywords" content="ETFs, exchange-traded funds, equity ETFs, bond ETFs, commodity ETFs, sector ETFs, fund flows, passive investing, index funds" />
        
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="ETF News & Analysis - Redbox Global" />
        <meta property="og:description" content="Latest ETF market news, fund flows, and comprehensive performance analysis from Redbox Global." />
        <meta property="og:url" content="https://redboxglobal.com/markets/etfs" />
        <meta property="og:image" content="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&h=630&fit=crop" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="ETF News & Analysis - Redbox Global" />
        <meta name="twitter:description" content="Latest ETF market news, fund flows, and comprehensive performance analysis." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&h=630&fit=crop" />
        
        <link rel="canonical" href="https://redboxglobal.com/markets/etfs" />
      </Helmet>

      <div className="etfs-page">
        <div className="container">
          {/* Breadcrumb */}
          <nav className="breadcrumb">
            <Link to="/">Home</Link>
            <span className="separator">/</span>
            <Link to="/markets">Markets</Link>
            <span className="separator">/</span>
            <span className="current">ETFs</span>
          </nav>

          {/* Page Header */}
          <header className="page-header">
            <h1 className="page-title">ETFs</h1>
            <p className="page-description">
              Comprehensive coverage of exchange-traded funds, fund flows, performance metrics, and investment strategies across all asset classes.
            </p>
          </header>

          {/* Featured Swiper Slider */}
          <section className="featured-section">
            <Swiper
              modules={[Autoplay, Pagination]}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              pagination={{ clickable: true }}
              loop
              className="etfs-swiper"
            >
              {etfsArticles.map((article) => (
                <SwiperSlide key={article.id}>
                  <article className="featured-article">
                    <Link to={`/article/${article.slug}`} className="featured-link">
                      <div className="featured-image">
                        <img src={article.image} alt={article.title} />
                        <span className="featured-category">{article.category}</span>
                      </div>
                    </Link>
                    <div className="featured-content">
                      <h2 className="featured-title">
                        <Link to={`/article/${article.slug}`}>{article.title}</Link>
                      </h2>
                      <p className="featured-subtitle">{article.subtitle}</p>
                      <div className="article-meta">
                        <span className="date">{article.time}</span>
                      </div>
                    </div>
                  </article>
                </SwiperSlide>
              ))}
            </Swiper>
          </section>

          {/* Bloomberg-style Two Column List */}
          <section className="bloomberg-two-columns">
            <div className="bloomberg-column">
              {etfsListLeft.map((item) => (
                <article key={item.id} className="bloomberg-item">
                  <Link to={`/article/${item.slug}`} className="bloomberg-link">
                    <div className="bloomberg-thumb">
                      <img src={item.image} alt={item.title} />
                    </div>
                    <div className="bloomberg-text">
                      <h3 className="bloomberg-title">{item.title}</h3>
                      <span className="bloomberg-time">{item.time}</span>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
            
            <div className="bloomberg-column">
              {etfsListRight.map((item) => (
                <article key={item.id} className="bloomberg-item">
                  <Link to={`/article/${item.slug}`} className="bloomberg-link">
                    <div className="bloomberg-thumb">
                      <img src={item.image} alt={item.title} />
                    </div>
                    <div className="bloomberg-text">
                      <h3 className="bloomberg-title">{item.title}</h3>
                      <span className="bloomberg-time">{item.time}</span>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ETFs;
